export default __webpack_public_path__ + "static/media/logo-text.83b159be.png";